import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

//UI
import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { useCallback } from 'react'
import { toast } from 'react-toastify'

//API

import { useCostCenter } from '@/features/costCenters/useCostCenter'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'

const CostCenterListHeader = () => {
  //Hook
  const dispatch = useDispatch()
  const {
    useFetchCostCenterUsers,
    useFetchAllCostCenters,
    useRemoveCostCenter,
    useUpdateCostCenter,
    useUploadCostCenters,
    useUploadUserInCostCenters,
  } = useCostCenter()

  const uploadCostCenters = useUploadCostCenters()
  const uploadUser = useUploadUserInCostCenters()

  const { data: allCostCentersResponse } = useFetchAllCostCenters({
    page: 1,
    pageSize: 0,
  })
  const { data: allCostCenterUserResponse } = useFetchCostCenterUsers()

  const handleDownload = useCallback(() => {
    try {
      const excelData = allCostCentersResponse.data.map((costCenter) => {
        return {
          profitCenterCode: costCenter.profitCenterCode,
          code: costCenter.code,
          name: costCenter.name,
          description: costCenter.description,
          quotationCode: costCenter.quotationCode,
          defaultProcurementOfficerEmail: costCenter?.defaultProcurementOfficerEmail || '',
          defaultTeamAssistantEmail: costCenter?.defaultTeamAssistantEmail || '',
          type: costCenter?.type || '',
          status: costCenter?.status || '',
        }
      })

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'E-Approval Cost Center.xlsx')
    } catch (err) {
      console.log(err)
    }
  }, [allCostCentersResponse?.data])
  const handleDownloadUser = useCallback(() => {
    try {
      const excelData = allCostCenterUserResponse?.data.map((user) => {
        return {
          ...user,
          isDefaultUser: user.isDefaultUser ? 'yes' : 'no',
          isBookingDefaultUser: user.isBookingDefaultUser ? 'yes' : 'no',
          isHighLevelApprovalDefault: user.isHighLevelApprovalDefault ? 'yes' : 'no',
        }
      })

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'E-Approval Cost Center User.xlsx')
    } catch (err) {
      console.log(err)
    }
  }, [allCostCenterUserResponse?.data])
  const handleUploadUser = (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    dispatch(showLoadingOverlay())
    uploadUser.mutate(file, {
      onSettled: () => {
        dispatch(hideLoadingOverlay())
      },
    })
  }

  const handleUpload = (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    dispatch(showLoadingOverlay())
    uploadCostCenters.mutate(file, {
      onSettled: () => {
        dispatch(hideLoadingOverlay())
      },
    })
  }

  return (
    <Flex alignItems="center" p={5} borderBottom="1px solid #d8dbe0" gap="3">
      <Heading>Cost Centers</Heading>

      <Flex direction={'column'} gap={2}>
        <HStack>
          <Button colorScheme="gray" onClick={handleDownload}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <HStack>
          <Button colorScheme="gray" onClick={handleDownloadUser}>
            Download User
          </Button>
          <NonFormUpload uploadHandler={handleUploadUser} title="Upload User" />
        </HStack>
      </Flex>

      <Spacer />
      <Link to="/admin/costCenters/create">
        <Button colorScheme="blue">Create Cost Center</Button>
      </Link>
    </Flex>
  )
}

export default CostCenterListHeader
